import React from 'react';
import { useTranslation } from 'react-i18next';

const ContactMethods = () => {
  const { t, ready } = useTranslation();

  // Evitar renderizar hasta que las traducciones estén listas
  if (!ready) {
    return null; // o mostrar un spinner/cargando
  }
  return (
    <div className="contact-methods-container">
      {/* Llamar por teléfono */}
      <div className="contact-item-1">
        <a href="tel:+302112340748">
          <img
          className='contact-image-1'
            src="/images/contact/movil_u.svg"
            alt="Llamar"
            loading='lazy'
          />
          <p className="pop1 modern-text">{t('free_call', '/')}</p>
          <p className="pop2 modern-text">+302112340748</p>
        </a>
      </div>

      {/* Agendar cita */}
      <div className="contact-item-2">
        <a href={t('agenda_link')}>
          <img
          className='contact-image-2'
            src="/images/contact/calendario_u.svg"
            alt="Agendar cita"
            loading='lazy'
          />
          <p className="pop1 modern-text">{t('calendar_contact_method', '/')}</p>
          <p className="pop2 modern-text">{t('calendar_call_contact_method', '/')}</p>
        </a>
      </div>

      {/* Recibir información por correo electrónico */}
      <div className="contact-item-3">
      <a href={(() => {
  const link = t('contact_method_link', '/');
  //console.log('Valor de contactLink:', link);
  return link;
})()}>
          <img
          className='contact-image-3'
            src="/images/contact/email_u.svg"
            alt="Correo electrónico"
            loading='lazy'
          />
          <p className="pop1 modern-text">{t('email_info_contact_method', '/')}</p>
          <p className="pop2 modern-text">{t('email_contact_method', '/')}</p>
        </a>
      </div>

      {/* Recibir información telefónica */}
      <div className="contact-item-4">
        <a href={t('contact_method_link', '/')}>
          <img
            src="/images/contact/llamada_u.svg"
            alt="Información telefónica"
            className='contact-image-4'
            loading='lazy'
          />
          <p className="pop1 modern-text">{t('call_info_contact_method', '/')}</p>
          <p className="pop2 modern-text">{t('call_phone_contact_method', '/')}</p>
        </a>
      </div>
    </div>
  );
};

export default ContactMethods;